byteSequenceLength